export const GET_REVIEW_SNIPPET = 'getReviewSnippet';

export type ServiceRatingsReviewsQueries = {
    [GET_REVIEW_SNIPPET]: {};
};

export type ServiceRatingsReviewsQueriesResponseType = {
    [GET_REVIEW_SNIPPET]: {};
};
